import axios from 'axios'
import { GroupResponse } from '../../common/GroupResponse'

export const getContactGroup = async () => {
  const { data } = await axios.get<GroupResponse[]>(
    `${process.env.REACT_APP_API_URL}/contactGroup`,
    {
      withCredentials: true,
    },
  )

  return data
}
